export class SuspicionStatusRequest {
    public isSuspicionEvaluated: boolean;
    public suspicionEvaluationMotive: string;
}